// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.support-dashboard {
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 1.75em 0;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Dashboards/SupportDashboard/SupportDashboard.less"],"names":[],"mappings":"AAEA;EACC,mBAAA;EACA,aAAA;EACA,OAAA;EACA,sBAAA;EACA,iBAAA;AADD","sourcesContent":["@import (reference) \"../../../Styles/colors\";\n\n.support-dashboard {\n\talign-items: center;\n\tdisplay: flex;\n\tflex: 1;\n\tflex-direction: column;\n\tpadding: 1.75em 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
